import { ValidatorResult } from '@unitedtraders/validators';
import { Money } from '../types/gql';

// t('validator:not enough balance')
export const inBalance =
  (balance: Money) =>
  (value: string): ValidatorResult =>
    value && +value > balance.value
      ? {
          key: 'validator:not enough balance',
          options: { balance },
        }
      : false;
